import {
  FORM_ADD_PAYTO_MAX_AMOUNT_NAME,
  PAYTO_LOG_TAG,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import withRoundUpPaytoMaxAmount from './withRoundUpPaytoMaxAmount';

const withAddPaytoAccountInitial = (Component) => {
  const AddPaytoAccountInitialComponent = withRoundUpPaytoMaxAmount((props) => {
    const { maxAmountInitialVer2, modalOptions } = props || {};
    const { paytoAccountInformationRetry } = modalOptions || {};

    const {
      setPaytoAccountInformation,
      resetPaytoAgreementEditing,
      // isAccountAgreementEditing,
    } = usePaytoStore();

    const [isAddManual, setAddManual] = useState(false);
    const [isAddPayIdManual, setAddPayIdManual] = useState(false);
    const [isAddTypeSelected, setAddTypeSelected] = useState(false);

    useEffect(() => {
      resetPaytoAgreementEditing();
    }, []);

    useEffect(() => {
      if (!isEmpty(paytoAccountInformationRetry)) {
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 withAddPaytoAccountInitial ➡️ paytoAccountInformationRetry ↩`,
          paytoAccountInformationRetry
        );
        setPaytoAccountInformation(paytoAccountInformationRetry);
      } else {
        const paytoAccountInformationInitial = {
          [FORM_ADD_PAYTO_MAX_AMOUNT_NAME]: `${maxAmountInitialVer2}`,
        };
        console.log(
          `⭐ ${PAYTO_LOG_TAG} 👉 withAddPaytoAccountInitial ➡️ paytoAccountInformationInitial ↩`,
          paytoAccountInformationInitial
        );
        setPaytoAccountInformation(paytoAccountInformationInitial);
      }
    }, []);

    useEffect(() => {
      if (!isAddManual && !isAddPayIdManual) setAddTypeSelected(false);
      if (isAddManual || isAddPayIdManual) {
        setAddTypeSelected(true);
      }
    }, [isAddManual, isAddPayIdManual]);

    const newProps = {
      ...props,
      isAddManual,
      setAddManual,
      isAddPayIdManual,
      setAddPayIdManual,
      isAddTypeSelected,
    };
    return <Component {...newProps} />;
  });
  return AddPaytoAccountInitialComponent;
};

export default withAddPaytoAccountInitial;
